//Any code inside here gets executed when the page loads
document.addEventListener("DOMContentLoaded", function() {
  //This grabs an html element based on a css selector and let's you change it!
  document.querySelector(
  "div.footer__aside-item.footer__aside-item--localization > p"
).innerHTML =
  '© 2022 Cardboard Classic Games LTD<br> All Rights Reserved \n- Powered by\n<a href="https://binderpos.com" target="_blank" rel="noopener" aria-describedby="a11y-new-window-message">BinderPOS</a>\n';
});

